import Siema from 'siema';

const App = (() => {
    const baseURI = window.location.hostname;
    let scrollExecuted = false;

    const init = () => {

        // window.addEventListener('scroll', executeOnScroll);
        // window.addEventListener('mousemove', executeOnScroll);
        // window.addEventListener('touchmove', executeOnScroll);
        window.addEventListener('scroll', checkScrollToLoadScripts);
        window.addEventListener('mousemove', checkScrollToLoadScripts);
        window.addEventListener('touchmove', checkScrollToLoadScripts);
    };

    const executeOnScroll = () => {
        loadSiema();
        setScrolling();
        searchLoader();
    };

    const checkScrollToLoadScripts = () => {

        if (!scrollExecuted) {
          window.removeEventListener('scroll', checkScrollToLoadScripts);
          window.removeEventListener('mousemove', checkScrollToLoadScripts);
          window.removeEventListener('touchmove', checkScrollToLoadScripts);

          executeOnScroll();
          scrollExecuted = true;
        }
    };

    const searchLoader = () => {
        document.querySelectorAll('a[href="#search"]').forEach(item => {
            item.addEventListener('click', event => {
              event.preventDefault();
              document.querySelector('#search').classList.add('open');
              document.querySelector('#searchoverlay').value = '';
              document.querySelector('#searchoverlay').focus();
            });
          });

          document
            .querySelector('.benefit-overlay button.close')
            .addEventListener('click', event => {
              if (event.target == this || event.target.className == 'close') {
                document.querySelector('#search').classList.remove('open');
              }
            });

          document.querySelector('.benefit-overlay').addEventListener('keyup', event => {
            if (event.target == this || event.keyCode == 27) {
              document.querySelector('#search').classList.remove('open');
            }
          });
          /*
          document.querySelectorAll('a[href="#menubar-toggler"]').forEach(item => {
            item.addEventListener('click', event => {
              event.preventDefault();
              document.querySelector('#menubar').classList.add('open');
            });
          });
          */

    };

    const setScrolling = () => {
      const thumbsImages = document.querySelector('.flex-control-thumbs');
      if (thumbsImages) {
        let items = document.querySelectorAll('.flex-control-thumbs li');
        if (items.length > 5) {

          // Get the element you want to add your new element before or after
          // var target = document.querySelector('#some-div');

          // Create the new element
          // This can be any valid HTML element: p, article, span, etc...
          var div = document.createElement('div');
          div.innerHTML = '';
          div.className = 'downScrolling';
          div.addEventListener('click', function () {
            let currentPosition = document.getElementsByClassName('flex-control-thumbs')[0].scrollTop;
            document.getElementsByClassName('flex-control-thumbs')[0].scrollTop = currentPosition + 30;
          });

          thumbsImages.parentNode.insertBefore( div, thumbsImages );

          // Insert the element after our target element
          thumbsImages.parentNode.insertBefore( div, thumbsImages.nextSibling );


        }
      }
    };

    const loadSiema = () => {

        if (document.querySelector('.siemaProductos')) {
            const siemaHomProdcutos = new Siema({
                selector: '.siemaProductos > .woocommerce > ul',
                perPage: {
                100: 1,
                500: 1,
                800: 3,
                1200: 4,
                },
            });
            document
                .querySelector('.siemaProductosPrev')
                .addEventListener('click', () => siemaHomProdcutos.prev());
            document
                .querySelector('.siemaProductosNext')
                .addEventListener('click', () => siemaHomProdcutos.next());
        }

        if (document.querySelector('.siemaProductos2')) {
            const siemaHomProdcutos2 = new Siema({
                selector: '.siemaProductos2 > .woocommerce > ul',
                perPage: {
                100: 1,
                500: 1,
                800: 3,
                1200: 4,
                },
            });
            document
                .querySelector('.siemaProductos2Prev')
                .addEventListener('click', () => siemaHomProdcutos2.prev());
            document
                .querySelector('.siemaProductos2Next')
                .addEventListener('click', () => siemaHomProdcutos2.next());
        }

        if (document.querySelector('.siemaRelated')) {
            const siemaRelated = new Siema({
                selector: '.siemaRelated',
                perPage: {
                100: 1,
                500: 1,
                800: 3,
                1200: 4,
                },
            });
            document
                .querySelector('.siemaRelatedPrev')
                .addEventListener('click', () => siemaRelated.prev());
            document
                .querySelector('.siemaRelatedNext')
                .addEventListener('click', () => siemaRelated.next());
        }


    };

    return {
        init: init,
    };
})();

export { App };